import NavigationBar from "../NavigationBar";
import React, { FC, useEffect, useState } from "react";
import { ResponseData } from "../adminpanel/panels/types/types";
import axios from "../../services/ApiConfig";
import { URLS } from "../../utility/UrlConstants";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Input from "../customhtmlcomponents/Input";
import {
  IntlNubmerFormatter,
  removeWhiteSpaces,
} from "../../utility/formatInputField";
import { pick } from "lodash";
import FooterButtons from "../customhtmlcomponents/FooterButtons";
import {
  inntekterTemplate,
  kasseOgBankTemplate,
  kostnaderTemplate,
} from "./RegnskapTabellTemplate";
import { AxiosResponse } from "axios";

interface IRegnskapstabellProps {
  currentForeningReportNumber: number;
  username: string;
  message: React.Dispatch<React.SetStateAction<{ body: ResponseData }>>;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type RegnskapState = {
  // 7.1 inntekter
  inntektFastelavensris: number;
  inntektMaiblomst: number;
  inntektAdventskalender: number;
  inntektBasarMesseUtlodningBingoMm: number;
  grasrotandelen: number;
  gaver: number;
  mvaRefusjon: number;
  tilbakefortKontigent: number;
  offentligeTilskudd: number;
  tilskuddSomErOremerket: number;
  andreInntekter: number;
  leieinntekterEgenEiendom: number;
  fasteLeieinntekterPaEgenEiendom: number;
  totaleInntekter: number;
  resultat: number;
  // 7.2 kostnader
  kostnadFastelavensris: number;
  kostnadMaiblomst: number;
  kostnadAdventskalender: number;
  kostnadBasarMesseUtlodningBingoMm: number;
  nksFondMinDagIDag: number;
  gaverOkonomiskeBidrag: number;
  aktiviteter: number;
  husleie: number;
  andreDriftsutgifter: number;
  driftskostnader: number;
  vedlikehold: number;
  avskrivninger: number;
  totaleKostnader: number;
  // 7.3 Beholdning
  kasseOgBank: number;
  beholdningObligasjonerAksjerVerdipapir: number;
  verdienAvFastEiendom: number;
};
const Regnskapstabell: FC<IRegnskapstabellProps> = ({
  currentForeningReportNumber,
  message,
  setModal,
}) => {
  const { register, setValue, handleSubmit, getValues } =
    useForm<RegnskapState>();
  const history = useHistory();
  const [kostnader, setKostnader] = useState(kostnaderTemplate);
  const [inntekter, setIntekter] = useState(inntekterTemplate);
  const [kasseOgBank, setKasseOgBank] = useState(kasseOgBankTemplate);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: `Regnskapstabell ble lagret.`,
        },
      },
    });
    setModal(true);
    setTimeout(() => setModal(false), 2650);
  };
  const saveOnClick = async (e: React.BaseSyntheticEvent, link: string) => {
    e.preventDefault();
    handleNavBarClick().then(() => history.push(link));
  };
  const handleNavBarClick = handleSubmit(() => {
    const formattedDto = prepareDto();
    let { resultat, ...rest } = formattedDto;

    const values = {
      foreningsNummer: currentForeningReportNumber,
      ...rest,
      resultat: 0,
    };
    postFormData(values, false)
  });

  const postFormData = async (dto: any, redirectToNextPage: boolean) => {
    setIsSubmitting(true);
    axios
      .post(URLS.REGNSKAP_POST, dto)
      .then((response: AxiosResponse<RegnskapState>) => {
        console.log(response);
        saveSuccessMessage();
        if(redirectToNextPage){
          setTimeout(
            () => {
              setIsSubmitting(false);
              history.push({
                pathname: "/avslutt",
                state: currentForeningReportNumber,
              })            
            }, 1750);
        }
      })
      .catch((error) => {
        console.log(error?.response?.data);
        message({
          body: {
            body: {
              error: "Dessverre feilet lagring av Regnskapstabell. Vennligst sjekk at alle felter er fylt inn med rett verdi og prøv igjen.",
            },
          },
        });
        setModal(true);
        setTimeout(() => {
          setModal(false);
          setIsSubmitting(false);
        }, 5000);
      });
  }


  useEffect(() => {
    async function getRegnskap() {
      await axios
        .get(`${URLS.REGNSKAP_GET}${currentForeningReportNumber}`, {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        })
        .then((response) => {
          Object.entries(response.data).forEach(([key, value]) => {
            console.log(key, value);
            // @ts-ignore
            setValue(key, IntlNubmerFormatter(value));
            updateTotals();
          });
          console.log(response.data);
        })
        .catch((err) => {
          console.log({ err });
          const x = Object.values(err);
          console.log(x);
        });
    }

    getRegnskap();
  }, [currentForeningReportNumber]);

  const sum = (args: {}) =>
    Object.values(args)
      .map((item) => removeWhiteSpaces(item as string))
      .reduce((a, b) => a + b, 0);

  const updateTotals = () => {
    const obj = getValues();
    const income = pick(obj, [
      "inntektFastelavensris",
      "inntektMaiblomst",
      "inntektAdventskalender",
      "inntektBasarMesseUtlodningBingoMm",
      "grasrotandelen",
      "gaver",
      "mvaRefusjon",
      "tilbakefortKontigent",
      "offentligeTilskudd",
      "tilskuddSomErOremerket",
      "andreInntekter",
      "leieinntekterEgenEiendom",
      "fasteLeieinntekterPaEgenEiendom",
    ]);
    const expenses = pick(obj, [
      "kostnadFastelavensris",
      "kostnadMaiblomst",
      "kostnadAdventskalender",
      "kostnadBasarMesseUtlodningBingoMm",
      "nksFondMinDagIDag",
      "gaverOkonomiskeBidrag",
      "aktiviteter",
      "husleie",
      "andreDriftsutgifter",
      "driftskostnader",
      "vedlikehold",
      "avskrivninger",
    ]);
    const totalIncome = sum(income);
    const totalExpenses = sum(expenses);
    setValue("totaleInntekter", IntlNubmerFormatter(totalIncome));
    setValue("totaleKostnader", IntlNubmerFormatter(totalExpenses));
    const result = totalIncome - totalExpenses;
    setValue("resultat", IntlNubmerFormatter(result));
  };

  const handleInntekerChange = (e: React.BaseSyntheticEvent) => {
    const { name, value } = e.target;
    setIntekter((prevState) =>
      prevState.map((intekt) => {
        if (intekt.name === name) {
          return { ...intekt, [name]: value };
        }
        return intekt;
      })
    );
    setValue(name, value);
    updateTotals();
    console.log(getValues());
  };
  
  const handleKostnaderChange = (e: React.BaseSyntheticEvent) => {
    const { name, value } = e.target;
    setKostnader((prevState) =>
      prevState.map((kostnad) => {
        if (kostnad.name === name) {
          return { ...kostnad, [name]: value };
        }
        return kostnad;
      })
    );
    setValue(name, value);
    updateTotals();
    console.log(getValues());
  };
  const handleKasseOgBankeChange = (e: React.BaseSyntheticEvent) => {
    const { name, value } = e.target;
    setKasseOgBank((prevState) =>
      prevState.map((kasseOgBank) => {
        if (kasseOgBank.name === name) {
          return { ...kasseOgBank, [name]: value };
        }
        return kasseOgBank;
      })
    );
    setValue(name, value);
  };
  const prepareDto = () => {
    let formValues = getValues();

    Object.entries(formValues).forEach(([key, value]) => {
      // @ts-ignore
      setValue(key, removeWhiteSpaces(value));
    });
    return getValues();
  };
  const submit = handleSubmit(() => {
    const formattedDto = prepareDto();
    let { resultat, ...rest } = formattedDto;

    const values = {
      foreningsNummer: currentForeningReportNumber,
      ...rest,
      resultat: 0,
    };

    postFormData(values, true)
  });

  return (
    <div className="place-content-center">
      <NavigationBar saveOnClick={saveOnClick} />
      <div className="flex justify-center md:justify-center ">
        <form onSubmit={submit}>
          <div>
            {/*div for table one and two grid */}

            <div>
              <p className="text-black text-center text-2xl font-bold mt-2py-2">
                7. Regnskapstabell
              </p>
            </div>
            {/* 7.1 & 7.2 wrapper */}
            <div className="grid">
              <div className="mt-4 content-center text-left lg:grid lg:grid-cols-2">
                {/*Table one starts here*/}
                <div className="justify-center flex flex-row m-auto w-2/3 transform scale-75">
                  <div className="mt-2 pb-3.5 self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl mb-8 lg:mb-0">
                    <div>
                      <p className="text-black text-center text-xl font-bold mt-4 py-2 pb-8">
                        7.1 Inntekter
                      </p>
                    </div>
                    <table className="table table-auto">
                      <thead>
                        <tr className="border-b border-sk-tertiary-blue">
                          <th className="w-1/16 pl-2 text-left text-xl font-thin">
                            Inntekter
                          </th>
                          <th className="w-1/16 pl-2 text-left text-xl font-thin">
                            Beløp
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {inntekter.map((item, index) => {
                          return (
                            <tr
                              key={index}
                              className="border-b border-sk-tertiary-blue"
                            >
                              <td className="whitespace-nowrap pl-2 pr-2 border-r border-sk-tertiary-blue text-left text-medium font-medium">
                                {item.text}
                              </td>
                              <td className="text-center text-xl font-thin flex p-2 cursor-pointer justify-end border-sk-tertiary-blue">
                                <Input
                                  className="text-center text-medium font-thin  text-right pr-2"
                                  type="text"
                                  maxLength={13}
                                  placeholder={item.placeholder}
                                  name={item.name}
                                  ref={register({
                                    required: true,
                                    min: 0,
                                  })}
                                  onChange={handleInntekerChange}
                                  id={item.name}
                                  label={item.name}
                                  labelopts={{
                                    defaultLabelStyle: false,
                                    labelOn: false,
                                  }}
                                  isNumberField={true}
                                />
                                <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                                  <span className="flex items-center px-2">
                                    NOK
                                  </span>
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="border-b border-sk-tertiary-blue">
                          <td className="text-center align-middle text-xl  p-5 cursor-pointer " />
                          <td className=" border-sk-tertiary-blue p-5 cursor-pointer" />
                        </tr>
                        <tr className="border-b border-sk-tertiary-blue"></tr>
                        <tr className="border-b border-sk-tertiary-blue">
                          <td className="text-center align-middle font-bold text-xl border-r border-sk-tertiary-blue p-5 cursor-pointer ">
                            TOTALE INNTEKTER
                          </td>
                          <td className="p-5 cursor-pointer flex justify-center">
                            <Input
                              ref={register}
                              className="text-center text-medium font-thin  text-right pr-2"
                              name="totaleInntekter"
                              label=""
                              id="totaleInntekter"
                              disabled
                              labelopts={{
                                defaultLabelStyle: false,
                                labelOn: false,
                              }}
                              placeholder="123.."
                              isNumberField={true}
                              type="text"
                            />
                            <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                              <span className="flex items-center px-2">
                                NOK
                              </span>
                            </span>
                          </td>
                        </tr>
                        <tr className="border-b border-sk-tertiary-blue">
                          <td className="text-center align-middle font-bold text-xl border-r border-sk-tertiary-blue p-5 cursor-pointer ">
                            RESULTAT
                          </td>
                          <td className="p-5 cursor-pointer flex justify-center">
                            <Input
                              className="text-center text-medium font-thin  text-right pr-2"
                              ref={register}
                              name="resultat"
                              label=""
                              id="resultat"
                              disabled
                              labelopts={{
                                defaultLabelStyle: false,
                                labelOn: false,
                              }}
                              placeholder="123.."
                              isNumberField={true}
                              type="text"
                            />
                            <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                              <span className="flex items-center px-2">
                                NOK
                              </span>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={2}
                            className="text-center text-red-800 align-middle font-bold text-xl   border-sk-tertiary-blue p-5 cursor-pointer "
                          >
                            NB! MÅ VÆRE SAMME SOM STÅR I ÅRSREGNSKAPET
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                {/*Table two starts here*/}
                <div className="justify-center flex flex-row m-auto w-2/3 transform scale-75">
                  <div className="pb-40 self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl">
                    <div>
                      <p className="text-black text-center text-xl font-bold mt-4 py-2 pb-8">
                        7.2 Kostnader
                      </p>
                    </div>
                    <table className="table table-auto">
                      <thead>
                        <tr className="border-b border-sk-tertiary-blue">
                          <th className="w-1/16 pl-2 text-left text-xl font-thin">
                            Kostnader
                          </th>
                          <th className="w-1/16 pl-2 text-left text-xl font-thin">
                            Beløp
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {kostnader.map((item, index) => {
                          return (
                            <tr
                              key={index}
                              className="border-b border-sk-tertiary-blue"
                            >
                              {item.input ? (
                                <td
                                  colSpan={item.colSpan}
                                  className="text-xl text-center text-red-800 font-bold border-sk-tertiary-blue p-5 cursor-pointer"
                                >
                                  KOSTNADER EGEN EIENDOM
                                </td>
                              ) : (
                                <>
                                  <td className="whitespace-nowrap pl-2 pr-2 border-r border-sk-tertiary-blue text-left text-medium font-medium">
                                    {item.text}
                                  </td>
                                  <td className="text-center text-xl font-thin flex p-2 cursor-pointer justify-end border-sk-tertiary-blue">
                                    <Input
                                      className="text-center text-medium font-thin  text-right pr-2"
                                      type="text"
                                      placeholder={item.placeholder}
                                      name={item.name}
                                      maxLength={13}
                                      ref={register({
                                        required: true,
                                        min: 0,
                                      })}
                                      onChange={handleKostnaderChange}
                                      id={item.name}
                                      label={item.name}
                                      labelopts={{
                                        defaultLabelStyle: false,
                                        labelOn: false,
                                      }}
                                      isNumberField={true}
                                    />
                                    <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                                      <span className="flex items-center px-2">
                                        NOK
                                      </span>
                                    </span>
                                  </td>
                                </>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="border-b border-sk-tertiary-blue">
                          <td className="text-center align-middle text-xl  p-5 cursor-pointer " />
                          <td className=" border-sk-tertiary-blue p-5 cursor-pointer" />
                        </tr>
                        <tr className="border-b border-sk-tertiary-blue"></tr>
                        <tr className="border-b border-sk-tertiary-blue">
                          <td className="text-center align-middle font-bold text-xl border-r border-sk-tertiary-blue p-5 cursor-pointer ">
                            TOTALE KOSTNADER
                          </td>
                          <td className="p-5 cursor-pointer flex justify-center">
                            <Input
                              ref={register}
                              className="text-center text-medium font-thin  text-right pr-2"
                              name="totaleKostnader"
                              label=""
                              id="totaleKostnader"
                              disabled
                              labelopts={{
                                defaultLabelStyle: false,
                                labelOn: false,
                              }}
                              placeholder="123.."
                              isNumberField={true}
                              type="text"
                            />
                            <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                              <span className="flex items-center px-2">
                                NOK
                              </span>
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-grow-0 flex-row m-auto justify-center transform scale-75">
              <div className="mt-2 pb-3.5 h-2/3 w-full xl:w-2/3 self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl">
                <div>
                  <p className="text-black text-center text-xl font-bold mt-4 py-2 pb-8">
                    7.3 Beholdning
                  </p>
                </div>
                <table className="table table-auto">
                  <thead>
                    <tr className="border-b border-sk-tertiary-blue">
                      <th className="w-1/4 pl-2 text-left text-xl font-thin">
                        Beskrivelse
                      </th>
                      <th className="w-1/4 pl-2 text-left text-xl font-thin">
                        Beløp
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {kasseOgBank.map((item, index) => {
                      return (
                        <tr
                          key={index}
                          className="border-b border-sk-tertiary-blue"
                        >
                          <td className="whitespace-nowrap pl-2 pr-2 border-r border-sk-tertiary-blue text-left text-medium font-medium">
                            {item.text}
                          </td>
                          <td className="text-center text-xl font-thin flex p-2 cursor-pointer justify-end border-sk-tertiary-blue">
                            <Input
                              className="text-center text-medium font-thin  text-right pr-2"
                              type="text"
                              maxLength={13}
                              placeholder={item.placeholder}
                              name={item.name}
                              ref={register}
                              onChange={handleKasseOgBankeChange}
                              id={item.name}
                              label={item.name}
                              labelopts={{
                                defaultLabelStyle: false,
                                labelOn: false,
                              }}
                              isNumberField={true}
                            />
                            <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                              <span className="flex items-center px-2">
                                NOK
                              </span>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <FooterButtons previousLocation="/gbm" saveOnClick={saveOnClick} isSubmitting={isSubmitting} />
        </form>
      </div>
    </div>
  );
};
export default Regnskapstabell;
